import AsideNavbar from 'src/components/AsideNavbar';
import { useEffect, useState, useCallback } from 'react';
import PortalNavBar from 'src/components/PortalNavbar';
import './style.css';
import Form from 'react-bootstrap/Form';
import { useUserContext } from 'src/contexts/UserContext';
import bannerLoja from 'src/img/banner.png';
import ImageSemFoto from 'src/img/semFoto.png';
import { api } from 'src/services/api';
import useUnsavedChangesWarning from 'src/services/hooks/useUnsavedChangesWarning';
import TextField from '@material-ui/core/TextField';
import ModalComponent from 'src/components/Modal/ModalComponent';
import useModal from 'src/services/hooks/useModal';

export function EditShop() {
  const urlLink = 'https://www.inventa.shop/collections/vendors?q=';
  const [siteLink, setSiteLink] = useState();
  const [multivendorName, setMultivendorName] = useState();
  const [nomeMarca, setNomeMarca] = useState();
  const [description, setDescription] = useState();
  const [tags, setTags] = useState([]);
  const [minhaLoja, setMinhaLoja] = useState();
  const [imagemBrandSend, setImagemBrandSend] = useState();
  const [imagemBackgroundSend, setImagemBackgroundSend] = useState();
  const { showToast, token } = useUserContext();
  const [nomeFornecedor, setNomeFornecedor] = useState('');
  const { routerPrompt, setDirty, setPristine } = useUnsavedChangesWarning();
  const [loading, setLoading] = useState(false);
  const [openModalComp, setOpenModal] = useModal();
  const [values, setValues] = useState({
    name: '',
  });

  const getShopData = useCallback(
    token => {
      if (token) {
        api
          .get('/supplier/supplier/brand-page', {
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
          })
          .then(res => {
            const { description, ...data } = res.data;
            setMinhaLoja({
              description: description
                ? description.substring(0, 500)
                : description,
              ...data,
            });
            setValues(prevValues => ({
              ...prevValues,
              name: res.data.description
                ? res.data.description.substring(0, 500)
                : res.data.description || '',
            }));

            setTags(res.data.tags ? res.data.tags : []);
            setPristine();
          });
      }
    },
    [setPristine],
  );

  useEffect(() => {
    getShopData(token);
  }, [getShopData, token]);

  useEffect(() => {
    if (token) {
      api
        .get('supplier/me', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
        })
        .then(res => {
          setNomeFornecedor(res.data);

          setMultivendorName(res.data.Multivendor);
          setSiteLink(urlLink + res.data.Multivendor);
        });
    }
  }, [token]);

  function handleChange(name, event) {
    setValues({ ...values, [name]: event.target.value });
  }

  const showError = useCallback(() => {
    showToast(
      `Não foi possível salvar os dados, por favor tente novamente em uns minutos.`,
      'error',
    );
    window.scroll(0, 0);
    setOpenModal(false);
  }, [setOpenModal, showToast]);

  function updateLoja() {
    setLoading(true);

    api
      .put(
        '/supplier/supplier/brand-page',
        {
          image_brand: imagemBrandSend || minhaLoja.image_brand,
          image_cover: imagemBackgroundSend || minhaLoja.image_cover,
          name: nomeMarca || minhaLoja.name,
          short_description: minhaLoja.short_description,
          valorMinimo: minhaLoja.valorMinimo,
          description: description || minhaLoja.description,
          website: minhaLoja.website,
          instagram: minhaLoja.instagram,
          facebook: minhaLoja.facebook,
          tags: tags || minhaLoja.tags,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
        },
      )
      .then(res => {
        setLoading(false);
        if (res.status === 200) {
          showToast(`Loja Atualizadada com sucesso!`, 'success');
          window.scroll(0, 0);
          setOpenModal(false);
        } else {
          showError();
        }
      })
      .catch(() => {
        setLoading(false);
        showError();
      });
  }

  function removePhotoBrand() {
    setImagemBrandSend('');
    setMinhaLoja({ ...minhaLoja, image_brand: '' });

    const imageContainer = document.querySelector('#brandLoja');
    imageContainer.setAttribute('src', ImageSemFoto);

    const inputFile = document.querySelector('#inputBrand');
    inputFile.value = '';
  }

  function removePhotoBackground() {
    setImagemBackgroundSend('');
    setMinhaLoja({ ...minhaLoja, image_cover: '' });

    const imageContainer = document.querySelector('#backgroundLoja');
    imageContainer.setAttribute('src', bannerLoja);

    const inputFile = document.querySelector('#inputBackground');
    inputFile.value = '';
  }

  const dimensionAlert = (file, type) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = e => {
      const image = new Image();
      image.src = e.target.result;
      image.onload = () => {
        if (type === 'brand' && image.width > 300 && image.height > 300) {
          showToast(
            'Atenção. Você está enviando uma imagem maior que 300x300px',
          );
        }
        if (type === 'cover' && image.width > 1440 && image.height > 300) {
          showToast(
            'Atenção. Você está enviando uma imagem maior que 1440x300px',
          );
        }
      };
    };
  };

  async function startUpload(file, creds) {
    const data = new FormData();

    Object.entries(creds.fields).forEach(([key, value]) => {
      data.append(key, value);
    });
    data.append('file', file);

    const raw = await fetch(creds.url, {
      method: 'POST',
      body: data,
    });
    setLoading(false);
    if (raw.status === 204) {
      // TODO: improve the way that the image url is mounted
      let imagemSalva = window.location.host.includes('.app')
        ? 'https://fornecedor.inventa.app.br/'
        : 'https://fornecedor.inventa.dev.br/';

      imagemSalva += `${creds.fields.key}?v=${new Date().getTime()}`;

      setImagemBrandSend(imagemSalva);

      const imageContainer = document.querySelector('#brandLoja');
      imageContainer.setAttribute('src', imagemSalva);
    }
  }

  async function startUploadCapa(file, creds) {
    const data = new FormData();
    Object.entries(creds.fields).forEach(([key, value]) => {
      data.append(key, value);
    });
    data.append('file', file);

    const raw = await fetch(creds.url, {
      method: 'POST',
      body: data,
    });
    setLoading(false);
    if (raw.status === 204) {
      // TODO: improve the way that the image url is mounted
      let imagemSalva = window.location.host.includes('.app')
        ? 'https://fornecedor.inventa.app.br/'
        : 'https://fornecedor.inventa.dev.br/';

      imagemSalva += `${creds.fields.key}?v=${new Date().getTime()}`;

      setImagemBackgroundSend(imagemSalva);

      const imageContainer = document.querySelector('#backgroundLoja');
      imageContainer.setAttribute('src', imagemSalva);
    }
  }

  const extensions = /(\.png|\.jpg|\.gif|\.tiff)$/i;

  function uploadPhoto(event, type) {
    event.preventDefault();
    const input = event.target;

    if (!extensions.exec(input.value)) {
      showToast(
        'Formato escolhido não é suportado, favor escolha outro arquivo',
        'error',
      );
      return;
    }
    if (input.files[0]) {
      const image_type = input.files[0].type;
      if (image_type.includes('image')) {
        api
          .get(
            `supplier/supplier/upload-image/${type}/${
              image_type.split('/')[1]
            }`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: token,
              },
            },
          )
          .then(res => {
            dimensionAlert(input.files[0], type);
            setLoading('uploadPhoto');
            startUpload(input.files[0], res.data);
          });
      }
    }
  }

  function uploadPhotoCover(event, type) {
    event.preventDefault();
    const input = event.target;

    if (!extensions.exec(input.value)) {
      showToast(
        'Formato escolhido não é suportado, favor escolha outro arquivo',
        'error',
      );
      return;
    }
    if (input.files[0]) {
      const image_type = input.files[0].type;
      if (image_type.includes('image')) {
        api
          .get(
            `supplier/supplier/upload-image/${type}/${
              image_type.split('/')[1]
            }`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: token,
              },
            },
          )
          .then(res => {
            dimensionAlert(input.files[0], type);
            setLoading('uploadPhotoCover');
            startUploadCapa(input.files[0], res.data);
          });
      }
    }
  }

  function triggerImage() {
    const inputFile = document.querySelector('#inputBrand');

    inputFile.click();
  }

  function triggerImageLoja() {
    const inputFile = document.querySelector('#inputBackground');

    inputFile.click();
  }

  /* MODAL UPDATE VALOR MINIMO */

  const copyLink = async () => {
    const name = multivendorName || '';
    const url = 'www.inventa.shop/collections/vendors?q=';
    await navigator.clipboard.writeText(url + name);
    showToast('link copiado', 'success');
  };

  return (
    <div id="wrapper">
      <AsideNavbar />
      <div id="page-wrapper">
        <PortalNavBar />
        {/* MODAL */}
        {openModalComp && (
          <ModalComponent
            title="Atualizar Loja"
            closeModal={() => setOpenModal(false)}
          >
            <p className="card-text pb-3">
              Você confirma estar preparado para atualizar o seu perfil Inventa
            </p>
            {loading ? (
              <button href="#" className="btn btn-confirm p-2">
                <div className="spinner-border " role="status" />
              </button>
            ) : (
              <button
                href="#"
                className="btn btn-confirm p-3"
                onClick={() => {
                  updateLoja();
                  setNomeMarca('');
                  setPristine();
                }}
              >
                Confirmar
              </button>
            )}
          </ModalComponent>
        )}
        {/* TITULO */}
        <div className="row border-bottom px-2 py-3">
          <div className="col-12 col-xl-8">
            <span className="fs-2">
              Loja {nomeFornecedor ? nomeFornecedor.Account_Name : ''}
            </span>
          </div>
          <div className="col-12 col-md-6 col-xl-2 my-3 my-xl-0">
            <button
              className="btn border border-2 border-dark fw-bold p-2"
              onClick={() => setOpenModal(true)}
            >
              Atualizar informações
            </button>
          </div>
          <div className="col-12 col-md-6 col-xl-2 d-flex align-items-center justify-content-md-end">
            <a
              className="text-secondary text-decoration-none d-inline-block"
              target="_blank"
              href={siteLink}
              rel="noreferrer"
            >
              <span className="text-center">
                <i
                  className="fas fa-external-link-alt d-block fs-5 "
                  aria-hidden="true"
                />
                <span
                  className="d-inline-block text-center lh-sm "
                  style={{ fontSize: '10px' }}
                >
                  Visualizar
                  <br /> página
                </span>
              </span>
            </a>
            <a
              className="text-secondary text-decoration-none d-inline-block mx-3 "
              onClick={copyLink}
            >
              <span className="text-center">
                <i className="fas fa-clone d-block fs-5" aria-hidden="true" />
                <span
                  className="d-inline-block text-center lh-sm"
                  style={{ fontSize: '10px' }}
                >
                  Copiar <br /> Endereço
                </span>
              </span>
            </a>
          </div>
        </div>
        {/* IMAGEN DE PERFIL */}
        <div className="row d-flex align-items-center p-4 border-bottom">
          <div className="col-12 col-xl-3">
            <div className="">
              <img
                alt="Brand"
                src={
                  minhaLoja && minhaLoja.image_brand
                    ? minhaLoja.image_brand
                    : ImageSemFoto
                }
                id="brandLoja"
                className=" img-fluid"
              />
            </div>
          </div>
          <div className="col-12 col-xl-6">
            <h5 className="fw-light mt-3">Sua marca</h5>
            <p className="text-secondary">
              Tamanho recomendado 300x300px <br />
              <strong>Formato PNG, JPG, GIF ou TIFF</strong>
            </p>
            <button
              className="btn input-white border border-dark border-2 mb-3"
              onClick={() => {
                removePhotoBrand();
                setDirty();
              }}
            >
              Remover
            </button>
          </div>
          <div className="col-12 col-xl-3">
            <Form>
              <Form.Group controlId="formFile">
                <div className="row">
                  <div className="col-12">
                    <button
                      className="btn input-black mt-4"
                      type="button"
                      onClick={triggerImage}
                    >
                      {loading === 'uploadPhoto' ? (
                        <div className="spinner-border " role="status" />
                      ) : (minhaLoja && minhaLoja.image_brand) ||
                        imagemBrandSend ? (
                        'Trocar Imagem'
                      ) : (
                        'Adicionar Imagem'
                      )}
                    </button>
                  </div>
                </div>
                <Form.Control
                  className="invisible"
                  style={{ width: '10px', height: '10px' }}
                  onChange={e => uploadPhoto(e, 'brand')}
                  name="image"
                  id="inputBrand"
                  type="file"
                  accept=".png,.jpg,.gif,.tiff, .jpeg"
                />
              </Form.Group>
            </Form>
          </div>
        </div>
        {/* IMAGEN DE PORTADA */}
        <div className="row d-flex align-items-center p-4 border-bottom">
          <div className="col-12 col-xl-3">
            <div className="">
              <img
                alt="Cover"
                src={
                  minhaLoja && minhaLoja.image_cover
                    ? minhaLoja.image_cover
                    : bannerLoja
                }
                className="img-capa w-100 img-fluid"
                id="backgroundLoja"
              />
            </div>
          </div>
          <div className="col-12 col-xl-6">
            <h5 className="fw-light mt-3">Imagem de fundo</h5>
            <p className="text-secondary">
              Localizada atrás da marca
              <br />
              Tamanho recomendado 1440x300px
              <br />
              <strong>Formato PNG, JPG, GIF ou TIFF</strong>
            </p>
            <button
              className="btn input-white border border-dark border-2 mb-3"
              onClick={() => {
                removePhotoBackground();
                setDirty();
              }}
            >
              Remover
            </button>
          </div>
          <div className="col-12 col-xl-3">
            <Form>
              <Form.Group controlId="formFileBackGround" c>
                <div className="row ">
                  <div className="col-12">
                    <button
                      className="btn input-black  mt-4"
                      type="button"
                      onClick={triggerImageLoja}
                    >
                      {loading === 'uploadPhotoCover' ? (
                        <div className="spinner-border " role="status" />
                      ) : (minhaLoja && minhaLoja.image_cover) ||
                        imagemBackgroundSend ? (
                        'Trocar Imagem'
                      ) : (
                        'Adicionar Imagem'
                      )}
                    </button>
                  </div>
                </div>
                <Form.Control
                  className="invisible"
                  style={{ width: '10px', height: '10px' }}
                  onChange={e => {
                    uploadPhotoCover(e, 'cover');
                    setDirty();
                  }}
                  name="imageBack"
                  id="inputBackground"
                  type="file"
                  accept=".png,.jpg,.gif,.tiff, .jpeg"
                />
              </Form.Group>
            </Form>
            {routerPrompt}
          </div>
        </div>
        {/* TITULO INFORMACION */}
        <div className="row px-2 mt-4 mb-2">
          <div className="col-12 col-lg-8">
            <h2 className="fw-light">Informações da loja</h2>
            <p style={{ fontSize: '1rem' }}>
              Facilite para que lojistas e revendendores conheçam a sua marca e
              os principais valores e momentos da sua história.
            </p>
          </div>
        </div>
        {/* INFORMACION */}
        <div className="row px-2 py-3">
          <div className="col-12 col-lg-8">
            <h6 className="fs-4">Dados da Loja</h6>
            <TextField
              className="mt-3 w-100"
              type="text"
              multiline
              rows={7}
              label="Descrição"
              variant="outlined"
              defaultValue={
                minhaLoja && minhaLoja.description ? minhaLoja.description : ''
              }
              onChange={e => {
                setDescription(e.target.value);
                setDirty();
              }}
              onInput={e => handleChange('name', e)}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                maxLength: 500,
              }}
              helperText={`${values.name.length}/500`}
              required
            />
          </div>
        </div>
        {/* BOTON DE ACTUALIZAR */}
        <div className="row px-2 py-3 mb-4">
          <div className="col-12">
            <button
              className="btn btn-confirm p-3"
              onClick={() => setOpenModal(true)}
            >
              Atualizar informações
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
